import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { CustomerAddeventModelComponent } from '../customer-addevent-model/customer-addevent-model.component';
import { SecondMeetingpopupComponent } from '../second-meetingpopup/second-meetingpopup.component';
import { EventEmitterService } from '../services/event-emitter.service';
import { LeadService } from '../services/lead.service';
import { SnackBarService } from '../services/snack-bar.service';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-secondmeeting',
  templateUrl: './secondmeeting.component.html',
  styleUrls: ['./secondmeeting.component.css'],
})
export class SecondmeetingComponent implements OnInit {
  dataSource: any = null;
  filterdata = null;
  displayedColumns: string[] = [
    'name',
    'email',
    'phone',
    'signup_date',
    'leads_status',
    'lead_summary',
    'schedule_a_meeting',
    'Action',
  ];
  isLoading = false;
  isShow = true;
  paginationData: any;
  pageEvent: PageEvent;

  constructor(
    private leadService: LeadService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private eventEmitterService: EventEmitterService
  ) {
    this.eventEmitterService.listen().subscribe((item) => {
      this.initDataSource();
    });
  }

  ngOnInit(): void {
    this.initDataSource();
  }

  initDataSource() {
    this.isLoading = true;
    const leadStatusName = {
      meetingStatusname: 'second_meeting',
    };
    this.leadService.getLeadlistByLeadstatus(leadStatusName).subscribe((data: any) => {
      this.paginationData = data.data;
      this.dataSource = data.data.data;
      this.isLoading = false;
    });
  }

  onPaginateChange(event: PageEvent) {
    const paginationData = {
      page: event.pageIndex + 1,
      pageLimit: event.pageSize,
      meetingStaus: 'second_meeting',
    };
    this.isLoading = true;
    this.leadService.paginationCall(paginationData).subscribe((data) => {
      this.dataSource = data.data.data;
      this.isLoading = false;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue) {
      this.isLoading = true;
      let object = {
        filterValue: filterValue,
        leadStatus: 'second_meeting'
      }
      this.leadService.firstmeetingFilter(object).subscribe((response) => {
        this.dataSource = response.data.data;
        this.isLoading = false;
      });
    }
    if (filterValue === '') { this.initDataSource(); }
  }

  editLeadStatus(id) {
    this.leadService.getLeadByID(id).subscribe((data) => {
      let editLeadData = {
        ishowFlag: this.isShow = true,
        leadData: data,
      };
      this.openDialog(editLeadData);
    });
  }

  deleteLead(id) {
    this.leadService.getLeadByID(id).subscribe((data) => {
      this.dialog.open(ConfirmationModalComponent, {
        data: {
          title: 'Confirm',
          message: 'Are you Sure You want to delete this Lead'
        },
      }).afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.leadService.deleteLeadById(id).subscribe((response) => {
            this.snackBarService.openSnackBar(response.message, 'success-class');
            if (response) {
              this.initDataSource();
            }
          });
        }
      })
    });
  }

  openDialog(data) {
    const dialogRef = this.dialog.open(SecondMeetingpopupComponent, {
      width: '60%',
      height: '68%',
      data: {
        custoMmerData: data,
      },
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  openCreateEventDialog(data) {
    const dialogRef = this.dialog.open(CustomerAddeventModelComponent, {
      width: '34%',
      // height: '68%',
      data: {
        custoMmerData: data,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

}
